// src/data/customCocktails/catalogue.js
// eslint-disable-next-line max-len
/** @type {import('../../types/cocktails').Cocktail[]} */
export const catalogue = [
  {
    cocktail_id: 'gin-tonic',
    name: 'ジントニック',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 800,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'トニックウォーター', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 5, unit: 'ml', required: false, notes: 'お好みで追加' }
    ],
    garnish: [{ name: 'ライムカット' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '炭酸の気泡を保つため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1,
    substitutions: [
      { replaces: 'ジン', with: 'ウォッカ', label: 'ウォッカトニックに変更' }
    ]
  },
  {
    cocktail_id: 'gin-fizz',
    name: 'ジンフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true, notes: 'フレッシュ推奨' },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '炭酸以外の材料をしっかり混ぜるため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gin-rickey',
    name: 'ジンリッキー',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムカット' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '炭酸を損なわないため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'gimlet',
    name: 'ギムレット',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 5, unit: 'ml', required: false }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '冷却とバランス調整のため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'white-lady',
    name: 'ホワイトレディ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'martini',
    name: 'マティーニ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ジン', amount: 60, unit: 'ml', required: true },
      { name: 'ドライベルモット', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オリーブ' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: '透明感を保つため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['herbal', 'strong'],
    recipeVersion: 1,
    substitutions: [
      { replaces: 'ジン', with: 'ウォッカ', label: 'ウォッカマティーニに変更' }
    ]
  },
  {
    cocktail_id: 'negroni',
    name: 'ネグローニ',
    baseCategory: 'spirits',
    baseIngredient: 'ジン',
    origin: 'イタリア',
    price: 1100,
    ingredients: [
      { name: 'ジン', amount: 30, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジピール' }],
    glass: 'ロックグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: '炭酸を含まないためステアが最適' } }
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックコレクション',
    tasteTags: ['bitter', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'moscow-mule',
    name: 'モスコミュール',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 800,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'ライムカット' }],
    glass: 'マグカップ',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '炭酸を損なわないため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'screwdriver',
    name: 'スクリュードライバー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'salty-dog',
    name: 'ソルティドッグ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 120, unit: 'ml', required: true },
      { name: '塩', amount: null, unit: 'to_taste', required: false, notes: 'グラスのリムに塩を付ける' }
    ],
    garnish: [{ name: 'グレープフルーツピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bloody-mary',
    name: 'ブラッディメアリー',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウォッカ', amount: 45, unit: 'ml', required: true },
      { name: 'トマトジュース', amount: 90, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: false },
      { name: '塩', amount: null, unit: 'to_taste', required: false },
      { name: 'コショウ', amount: null, unit: 'to_taste', required: false, notes: 'お好みで' }
    ],
    garnish: [{ name: 'セロリスティック' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['umami', 'spicy'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'balalaika',
    name: 'バラライカ',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'ホワイトキュラソー', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'kamikaze',
    name: '神風',
    baseCategory: 'spirits',
    baseIngredient: 'ウォッカ',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウォッカ', amount: 30, unit: 'ml', required: true },
      { name: 'ホワイトキュラソー', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'strong'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'rum-tonic',
    name: 'ラムトニック',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'グローバル',
    price: 800,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'トニックウォーター', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 5, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'ライムカット' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'cuba-libre',
    name: 'キューバリブレ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 800,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'コーラ', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sol-cubano',
    name: 'ソルクバーノ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 90, unit: 'ml', required: true },
      { name: 'トニックウォーター', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'pineapple-fizz',
    name: 'パイナップルフィズ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'グローバル',
    price: 900,
    ingredients: [
      { name: 'ラム', amount: 30, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'daiquiri',
    name: 'ダイキリ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'キューバ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'xyz',
    name: 'XYZ',
    baseCategory: 'spirits',
    baseIngredient: 'ラム',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ラム', amount: 30, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-tonic',
    name: 'テコニック',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 800,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'トニックウォーター', amount: 120, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'el-diablo',
    name: 'エルディアブロ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 800,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'クレームドカシス', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['spicy', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-sunrise',
    name: 'テキーラサンライズ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'straw-hat',
    name: 'ストローハット',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: '日本',
    price: 900,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'トマトジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'セロリスティック' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['umami', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'tequila-sunrise',
    name: 'テキーラサンライズ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'アメリカ',
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'matador',
    name: 'マタドール',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 45, unit: 'ml', required: true },
      { name: 'パイナップルジュース', amount: 45, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'パイナップルピース' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'margarita',
    name: 'マルガリータ',
    baseCategory: 'spirits',
    baseIngredient: 'テキーラ',
    origin: 'メキシコ',
    price: 1000,
    ingredients: [
      { name: 'テキーラ', amount: 35, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 20, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true },
      { name: '塩', amount: null, unit: 'to_taste', required: false, notes: 'グラスのリムに塩を付ける' }
    ],
    garnish: [{ name: 'ライムスライス' }],
    glass: 'マルガリータグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake',
      restrictions: { shake_only: { reason: '柑橘と甘味の乳化が必要' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'jack-rose',
    name: 'ジャックローズ',
    baseCategory: 'spirits',
    baseIngredient: 'アップルブランデー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'アップルブランデー', amount: 45, unit: 'ml', required: true },
      { name: 'グレナデンシロップ', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'french-connection',
    name: 'フレンチコネクション',
    baseCategory: 'spirits',
    baseIngredient: 'コニャック',
    origin: 'フランス',
    price: 1000,
    ingredients: [
      { name: 'コニャック', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 25, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'olympic',
    name: 'オリンピック',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1100,
    ingredients: [
      { name: 'ブランデー', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジキュラソー', amount: 20, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'sidecar',
    name: 'サイド・カー',
    baseCategory: 'spirits',
    baseIngredient: 'ブランデー',
    origin: 'フランス',
    price: 1200,
    ingredients: [
      { name: 'ブランデー', amount: 35, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'bourbon-buck',
    name: 'バーボンバック',
    baseCategory: 'spirits',
    baseIngredient: 'バーボン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'バーボン', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'john-collins',
    name: 'ジョンコリンズ',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: 'ウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 20, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'コリンズグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'godfather',
    name: 'ゴッドファーザー',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'イタリア',
    price: 900,
    ingredients: [
      { name: 'ウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'アマレット', amount: 25, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ロックグラス',
    method: 'build',
    methodRules: {
      allowed: ['build', 'stir'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'hunter',
    name: 'ハンター',
    baseCategory: 'spirits',
    baseIngredient: 'ライウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ライウイスキー', amount: 45, unit: 'ml', required: true },
      { name: 'チェリーブランデー', amount: 20, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'churchill',
    name: 'チャーチル',
    baseCategory: 'spirits',
    baseIngredient: 'スコッチウイスキー',
    origin: 'イギリス',
    price: 1000,
    ingredients: [
      { name: 'スコッチウイスキー', amount: 30, unit: 'ml', required: true },
      { name: 'コアントロー', amount: 15, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 15, unit: 'ml', required: true },
      { name: 'ライムジュース', amount: 10, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムピール' }],
    glass: 'カクテルグラス',
    method: 'shake',
    methodRules: {
      allowed: ['shake'],
      default: 'shake'
    },
    isOnCurrentMenu: true,
    tasteTags: ['citrus', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'manhattan',
    name: 'マンハッタン',
    baseCategory: 'spirits',
    baseIngredient: 'ウイスキー',
    origin: 'アメリカ',
    price: 1000,
    ingredients: [
      { name: 'ウイスキー', amount: 50, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 20, unit: 'ml', required: true },
      { name: 'アンゴスチュラビターズ', amount: 2, unit: 'dash', required: true }
    ],
    garnish: [{ name: 'チェリー' }],
    glass: 'カクテルグラス',
    method: 'stir',
    methodRules: {
      allowed: ['stir'],
      default: 'stir',
      restrictions: { stir_only: { reason: '透明度を保つクラシックレシピ' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['bitter', 'rich'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'cassiss-orange',
    name: 'カシスオレンジ',
    baseCategory: 'liqueurs',
    baseIngredient: 'カシスリキュール',
    origin: '日本',
    price: 800,
    ingredients: [
      { name: 'カシスリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'fuzzy-navel',
    name: 'ファジーネーブル',
    baseCategory: 'liqueurs',
    baseIngredient: 'ピーチリキュール',
    origin: 'アメリカ',
    price: 800,
    ingredients: [
      { name: 'ピーチリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'オレンジジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'spumoni',
    name: 'スプモーニ',
    baseCategory: 'liqueurs',
    baseIngredient: 'カンパリ',
    origin: 'イタリア',
    price: 800,
    ingredients: [
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 60, unit: 'ml', required: true },
      { name: 'トニックウォーター', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'グレープフルーツピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['bitter', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'evergreen-forest',
    name: '照葉樹林',
    baseCategory: 'liqueurs',
    baseIngredient: 'グリーンティーリキュール',
    origin: '日本',
    price: 900,
    ingredients: [
      { name: 'グリーンティーリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'ミルク', amount: 60, unit: 'ml', required: true },
      { name: '砂糖シロップ', amount: 10, unit: 'ml', required: false, notes: 'お好みで調整' }
    ],
    garnish: [{ name: 'ミント' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: 'ミルクの層を保つため軽くビルド' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'herbal'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'spritz',
    name: 'スプリッツァー',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'オーストリア',
    price: 800,
    ingredients: [
      { name: '白ワイン', amount: 90, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 60, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンピール' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'kir',
    name: 'キール',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'フランス',
    price: 800,
    ingredients: [
      { name: '白ワイン', amount: 90, unit: 'ml', required: true },
      { name: 'カシスリキュール', amount: 15, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'floral'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'americano',
    name: 'アメリカーノ',
    baseCategory: 'liqueurs',
    baseIngredient: 'カンパリ',
    origin: 'イタリア',
    price: 900,
    ingredients: [
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true },
      { name: 'スイートベルモット', amount: 30, unit: 'ml', required: true },
      { name: 'ソーダ', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'オレンジスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: false,
    stockLabel: 'クラシックコレクション',
    tasteTags: ['bitter', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'china-blue',
    name: 'チャイナブルー',
    baseCategory: 'liqueurs',
    baseIngredient: 'ライチリキュール',
    origin: '日本',
    price: 800,
    ingredients: [
      { name: 'ライチリキュール', amount: 30, unit: 'ml', required: true },
      { name: 'ブルーキュラソー', amount: 10, unit: 'ml', required: true },
      { name: 'グレープフルーツジュース', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'グレープフルーツピール' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'malibu-coke',
    name: 'マリブコーク',
    baseCategory: 'liqueurs',
    baseIngredient: 'マリブリキュール',
    origin: 'アメリカ',
    price: 800,
    ingredients: [
      { name: 'マリブリキュール', amount: 45, unit: 'ml', required: true },
      { name: 'コーラ', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'ライムウェッジ' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'amaretto-ginger',
    name: 'アマレットジンジャー',
    baseCategory: 'liqueurs',
    baseIngredient: 'アマレット',
    origin: 'イタリア',
    price: 800,
    ingredients: [
      { name: 'アマレット', amount: 45, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'spicy'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'operator',
    name: 'オペレーター',
    baseCategory: 'liqueurs',
    baseIngredient: '白ワイン',
    origin: 'ドイツ',
    price: 800,
    ingredients: [
      { name: '白ワイン', amount: 90, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['refreshing', 'spicy'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'kitty',
    name: 'キティ',
    baseCategory: 'liqueurs',
    baseIngredient: '赤ワイン',
    origin: 'フランス',
    price: 800,
    ingredients: [
      { name: '赤ワイン', amount: 90, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 90, unit: 'ml', required: true }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'ワイングラス',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'american-lemonade',
    name: 'アメリカンレモネード',
    baseCategory: 'liqueurs',
    baseIngredient: '赤ワイン',
    origin: 'アメリカ',
    price: 900,
    ingredients: [
      { name: '赤ワイン', amount: 60, unit: 'ml', required: true },
      { name: 'レモネード', amount: 90, unit: 'ml', required: true },
      { name: 'レモンジュース', amount: 10, unit: 'ml', required: false }
    ],
    garnish: [{ name: 'レモンスライス' }],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'citrus'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'shandy-gaff',
    name: 'シャンディガフ',
    baseCategory: 'liqueurs',
    baseIngredient: 'ビール',
    origin: 'イギリス',
    price: 800,
    ingredients: [
      { name: 'ビール', amount: 120, unit: 'ml', required: true },
      { name: 'ジンジャーエール', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build',
      restrictions: { build_only: { reason: '炭酸を活かすため' } }
    },
    isOnCurrentMenu: true,
    tasteTags: ['spicy', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'panache',
    name: 'パナシェ',
    baseCategory: 'liqueurs',
    baseIngredient: 'ビール',
    origin: 'フランス',
    price: 800,
    ingredients: [
      { name: 'ビール', amount: 120, unit: 'ml', required: true },
      { name: 'レモネード', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['sweet', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'campari-beer',
    name: 'カンパリビア',
    baseCategory: 'liqueurs',
    baseIngredient: 'ビール',
    origin: 'イタリア',
    price: 800,
    ingredients: [
      { name: 'ビール', amount: 120, unit: 'ml', required: true },
      { name: 'カンパリ', amount: 30, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['bitter', 'refreshing'],
    recipeVersion: 1
  },
  {
    cocktail_id: 'red-eye',
    name: 'レッドアイ',
    baseCategory: 'liqueurs',
    baseIngredient: 'ビール',
    origin: '日本',
    price: 900,
    ingredients: [
      { name: 'ビール', amount: 120, unit: 'ml', required: true },
      { name: 'トマトジュース', amount: 120, unit: 'ml', required: true }
    ],
    garnish: [],
    glass: 'タンブラー',
    method: 'build',
    methodRules: {
      allowed: ['build'],
      default: 'build'
    },
    isOnCurrentMenu: true,
    tasteTags: ['umami', 'refreshing'],
    recipeVersion: 1
  }
];
